import { Binder } from '@ribajs/core'
import { ShopifyCartService } from '../services/index.js'
import { ShopifyCartObject } from '../types/index.js'
import { Disposer } from '../../gen-2/lib/disposables.js'

/**
 * Sets the shopify items count
 */
export class ShopifyCartCountBinder extends Binder<void, HTMLElement> {
  static key = 'shopify-cart-count'
  #disposer = new Disposer()

  private onCartChanged = (cart: ShopifyCartObject) => {
    this.setCount(cart.item_count)
  }

  private setCount(count: number) {
    if (!count) {
      this.el.textContent = ''
      if (this.el.parentElement) {
        this.el.parentElement.style.display = 'none'
      }
      return
    }
    if (this.el.parentElement) {
      this.el.parentElement.style.display = ''
    }
    this.el.textContent = String(count)
  }

  routine() {
    //
  }

  bind() {
    this.#disposer.add(
      ShopifyCartService.cartSignal.subscribe(
        cart => cart && this.onCartChanged(cart),
      ),
    )
  }

  unbind() {
    this.#disposer.dispose()
  }
}
